import React, { CSSProperties, forwardRef, HTMLAttributes, ReactNode } from 'react'
import classNames from 'classnames'


interface ContentPlaceholderProps extends HTMLAttributes<HTMLDivElement|HTMLSpanElement> {
    width?: number|string
    height?: number|string
    shape?: 'rounded'|'react'|'circle'
    className?: string
    style?: object
    children?: ReactNode
}


const ContentPlaceholder = forwardRef<HTMLDivElement, ContentPlaceholderProps>(({
    width = '100%',
    height = 13,
    shape = 'rounded',
    className,
    style = {},
    children,
    ...otherProps
}, ref) => {

    const _className = classNames(
        'content-placeholder',
        'soft-pulse',
        shape,
        className
    )

    const borderRadius = (shape === 'circle') ? {borderRadius: '50%'} : {}

    const combinedStyle = {
        ...{ backgroundColor: 'var(--bs-secondary-bg-subtle)' },
        width,
        height,
        ...borderRadius,
        ...style // This will merge and overwrite as needed
    } as CSSProperties

    return (
        <div
            ref={ref}
            className={_className}
            style={combinedStyle}
            {...otherProps}>
            {children}
        </div>
    )
})

export { ContentPlaceholder }
